import React from 'react';
import PropTypes from 'prop-types';
import {Icon as SemanticIcon} from 'semantic-ui-react';
import {get as _get} from 'lodash';

import {Alert} from '@ui';

/**
 * Display some additional information about time near start/end time
 */
export const GetDateTimeFieldValue = (props) => {
    const {event, matchDateKey, label} = props;

    let eventDatetime = _get(event, matchDateKey, null);

    if (null !== eventDatetime) {
        eventDatetime = eventDatetime.slice(0, -3);
    } else {
        eventDatetime = '-';
    }

    return (
        getWarningContent(event, 'sr_event', matchDateKey, label, eventDatetime) ||
        getWarningContent(event, 'st_event', matchDateKey, label, eventDatetime) ||
        eventDatetime
    );
};

export const getWarningContent = (event, prefix, matchDateKey, label, eventDatetime) => {
    if (
        _get(event, `${prefix}.id`, false) &&
        false === _get(event, `${prefix}.synchronise_times`, false)
    ) {
        const datePath = 'sr_event' === prefix
            ? `${prefix}.match.${matchDateKey}`
            : `${prefix}.stage.${matchDateKey}`;
        const dateTime = _get(event, datePath, null);

        if (dateTime) {
            return (
                <div className='startInfoContainer'>
                    {eventDatetime} <SemanticIcon name='warning circle sign' color='red'/>
                    <Alert className='onHoverInfo' icon={false} >
                        This time is not synchronised with Sportradar!<br/>
                        Original Sportradar {label} time: {dateTime.slice(0, -3)}
                    </Alert>
                </div>
            );
        }
    }

    return null;
};

GetDateTimeFieldValue.propTypes = {
    event: PropTypes.shape({
        sr_event: PropTypes.shape({
            id: PropTypes.string,
            match: PropTypes.object,
            synchronise_times: PropTypes.bool,
        }),
    }).isRequired,
    matchDateKey: PropTypes.oneOf(['start_datetime', 'end_datetime']).isRequired,
    label: PropTypes.string.isRequired,
};

GetDateTimeFieldValue.defaultProps = {
    event: {
        sr_event: {
            id: null,
            match: null,
            synchronise_times: null,
        },
    },
};
